var version = "1.1.5";

var dateFormatFilter = function (date, format) {
    if (date === void 0) { date = new Date(); }
    if (format === void 0) { format = 'YYYY.MM.DD HH:mm:ss'; }
    return format
        .replace('YYYY', "" + date.getFullYear())
        .replace('YY', "" + date.getFullYear() % 100)
        .replace('MM', ("" + (date.getMonth() + 1)).padStart(2, '0'))
        .replace('M', "" + (date.getMonth() + 1))
        .replace('DD', ("" + date.getDate()).padStart(2, '0'))
        .replace('D', "" + date.getDate())
        .replace('HH', ("" + date.getHours()).padStart(2, '0'))
        .replace('H', "" + date.getHours())
        .replace('hh', ("" + date.getHours() % 12).padStart(2, '0'))
        .replace('h', "" + date.getHours() % 12)
        .replace('mm', ("" + date.getMinutes()).padStart(2, '0'))
        .replace('m', "" + date.getMinutes())
        .replace('ss', ("" + date.getSeconds()).padStart(2, '0'))
        .replace('s', "" + date.getSeconds())
        // Always last
        .replace('A', date.getHours() < 12 ? 'AM' : 'PM')
        .replace('a', date.getHours() < 12 ? 'am' : 'pm');
};

var main$1 = {
    install: function (Vue) {
        Vue.filter('dateFormat', dateFormatFilter);
    },
    version: version
};

export default main$1;
export { dateFormatFilter };
